<div class="bottom-sheet-data-wrapper">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
        <div class="bottom-sheet-data"  *ngIf="!isInviteTradee && !isInviteTenant">
            <span class="ms-5 me-3"><span class="ms-5">{{confirmationMessage}}</span></span>
            <button (click)="closeBottomSheet(true)" class="common-button success mat-elevation-z0 mx-1" mat-button
                mat-raised-button>
                Yes
            </button>
            <button (click)="closeBottomSheet(false)" class="common-button black mat-elevation-z0 mx-1" mat-button
                mat-raised-button>
                No
            </button>
        </div>
    <div class="bottom-sheet-data" *ngIf="isInviteTradee">
        <div class="d-flex align-items-center py-1">
            <span class="mx-5 text-start font-14">{{confirmationMessage}}</span>
            <div class="d-flex align-items-center">
                <button (click)="closeBottomSheet(true)" class="common-button success mat-elevation-z0 mx-1" mat-button
                 mat-raised-button>
                    Yes
                </button>
                <button (click)="closeBottomSheet(false)" class="common-button black mat-elevation-z0 mx-1" mat-button
                    mat-raised-button>
                    No
                </button>
            </div>
        </div>
    </div>
    <div class="bottom-sheet-data" *ngIf="isInviteTenant">
        <div class="d-flex align-items-center py-1 justify-content-center">
            <span class="mx-5 text-start font-14">{{confirmationMessage}}</span>
            <div class="d-flex align-items-center">
                <button (click)="closeBottomSheet(true)" class="common-button success mat-elevation-z0 mx-1" mat-button
                 mat-raised-button>
                 Proceed
                </button>
                <button (click)="closeBottomSheet(false)" class="common-button black mat-elevation-z0 mx-1" mat-button
                    mat-raised-button>
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>